import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Grade code -> display label
export const gradeLabel = (code) => {
  if (!code) return "—";
  const c = String(code).trim().toUpperCase();
  if (c === "SR+") return "College";
  if (c === "HS") return "High School";
  if (c === "ADULT") return "Adult";
  return c;
};

// Grade code -> role classification for letter
// SR+ -> College; HS -> High School; ADULT -> Adult; blank -> plain Assistant Counselor.
export const roleForAsst = (grade) => {
  const c = String(grade || "").trim().toUpperCase();
  if (c === "SR+") return "Assistant Counselor - College";
  if (c === "HS") return "Assistant Counselor - High School";
  if (c === "ADULT") return "Assistant Counselor - Adult";
  return "Assistant Counselor";
};

// Grade code -> { tip_amounts key prefix, letter label }
// blank grade => no rate keys (row will be skipped on the letter).
export const rateKeysForGrade = (grade) => {
  const c = String(grade || "").trim().toUpperCase();
  if (c === "SR+") {
    return { full: "asst_college_full", half: "asst_college_half", label: "Assistant Counselor - College" };
  }
  if (c === "HS") {
    return { full: "asst_hs_full", half: "asst_hs_half", label: "Assistant Counselor - High School" };
  }
  if (c === "ADULT") {
    return { full: "asst_adult_full", half: "asst_adult_half", label: "Assistant Counselor - Adult" };
  }
  return { full: null, half: null, label: "Assistant Counselor" };
};

export const divisionOrder = ["Skipper", "Mariner", "Navigator"];

export const divisionMeta = {
  Skipper: {
    label: "Skippers",
    range: "N Groups (N1 - N16)",
    subtitle: "Pre-K & Kindergarten",
    accent: "coral",
  },
  Mariner: {
    label: "Mariners",
    range: "Boys B1–B11 · Girls G1–G11",
    subtitle: "Elementary Grades",
    accent: "gold",
  },
  Navigator: {
    label: "Navigators",
    range: "Boys B12–B15 · Girls G12–G15",
    subtitle: "Middle School & Up",
    accent: "teal",
  },
};
